import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { EventRecord } from '@/pages/event-types'

export function EventTurnout({ event }: { event: EventRecord }) {
  if (event.expected_seat_count === undefined || event.checked_in_count === undefined) return null
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-subheading">Turnout</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-body-sm text-foreground">
          <span className="font-medium tabular-nums">{event.checked_in_count}</span>{' '}
          <span className="text-muted-foreground">
            checked-in of {event.expected_seat_count} expected
          </span>
        </p>
        <div className="divide-y divide-border border-y border-border">
          {event.ticket_types.map((ticket) => (
            <div key={ticket.id} className="flex items-center justify-between py-2 text-body-sm">
              <span className="text-foreground">{ticket.name}</span>
              <span className="tabular-nums text-muted-foreground">
                {ticket.checked_in_count ?? 0} checked-in of {ticket.expected_count ?? 0} expected
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
